import Cookies from 'js-cookie'
import _ from 'lodash'

// const isBrowserLanguageAvailable = (languages) => {
//   const lang = window.navigator.userLanguage || window.navigator.language
//   const browserLang = _.find(languages, l => lang.includes(l.code))
//   if (browserLang) return browserLang
// }

export default (s = window.settings, langCode) => {
  const userLanguageSelection = 'userLanguageSelection'
  const lc = Cookies.get(userLanguageSelection, langCode)
  const browserLang = false //isBrowserLanguageAvailable(s.languages && s.languages.languages)
  let output = ''
      
  if (langCode) {
    output = langCode;
    Cookies.set(userLanguageSelection, langCode)
  } else if (lc) {
    output = lc
  } else if (browserLang) {
    output = browserLang.code
    Cookies.set(userLanguageSelection, browserLang.code)
  } else if (s.languages) {
    const defaultLangCode = s.languages.default.code
    Cookies.set(userLanguageSelection, defaultLangCode)
    output = defaultLangCode
  }
  return output
}
